import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { MatchDesk } from '../MatchDesk';
import { EGamePhase, } from '../../../types';
import { useAppSelector } from '../../../hooks';
import { selectMatchState } from '../../../store/match';
const Container = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
  overflow: hidden;
  //background: #999999;
  background-size: cover;
  height: 100vh;
  width: 100vw;
  min-width: 780px;
  min-height: 720px;
`;
export function DeskPool({ onPlayerClickAction, gameButtonState, addOnComponent }) {
    const matchState = useAppSelector(selectMatchState);
    const [matchPlayers, setMatchPlayers] = useState([]);
    const [deskPool, setDeskPool] = useState(null);
    const [viewDesk, setViewDesk] = useState(1);
    const [currentPlayerId, setCurrentPlayerId] = useState(null);
    useEffect(() => {
        setMatchPlayers((matchState === null || matchState === void 0 ? void 0 : matchState.players) || []);
    }, [matchState]);
    const playerInDesk = (playerId, players) => !!players.find((p) => p.id === playerId);
    const findDeskByPlayer = (playerId) => {
        const res = deskPool === null || deskPool === void 0 ? void 0 : deskPool.pool.find((desk) => playerInDesk(playerId, desk.players));
        // console.log('DeskPool findDeskByPlayer', res)
        return res === null || res === void 0 ? void 0 : res.deskNumber;
    };
    useEffect(() => {
        if (!currentPlayerId)
            return;
        const res = findDeskByPlayer(currentPlayerId);
        setViewDesk(res || 1);
    }, [currentPlayerId]);
    return (_jsx(Container, Object.assign({ day: (matchState === null || matchState === void 0 ? void 0 : matchState.gamePhase) === EGamePhase.DAY }, { children: _jsx("div", { children: _jsx(MatchDesk, { players: matchPlayers, onClickPlayerAction: onPlayerClickAction, gameButtonState: gameButtonState, setCurrentPlayerId: setCurrentPlayerId, addOnComponent: addOnComponent }) }) })));
}
